var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3H14.5C14.8978 3 15.2794 3.14816 15.5607 3.41189C15.842 3.67561 16 4.03329 16 4.40625V18H4V4.40625C4 4.03329 4.15803 3.67561 4.43933 3.41189C4.72064 3.14816 5.10218 3 5.5 3ZM11 17.0625V14.25H9V17.0625H11ZM5 17.0625H8V13.7812C8 13.6569 8.05269 13.5377 8.14645 13.4498C8.24022 13.3619 8.36739 13.3125 8.5 13.3125H11.5C11.6326 13.3125 11.7598 13.3619 11.8535 13.4498C11.9473 13.5377 12 13.6569 12 13.7812V17.0625H15V4.40625C15 4.28193 14.9473 4.16271 14.8535 4.0748C14.7598 3.98689 14.6326 3.9375 14.5 3.9375H5.5C5.36739 3.9375 5.24022 3.98689 5.14645 4.0748C5.05269 4.16271 5 4.28193 5 4.40625V17.0625ZM13 5.8125H11V7.6875H13V5.8125ZM9 5.8125H7V7.6875H9V5.8125ZM13 9.5625H11V11.4375H13V9.5625ZM9 9.5625H7V11.4375H9V9.5625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/CompanyIcon.894fa5e539086920c26bdd69729a1ab9.svg";
export { ForwardRef as ReactComponent };